module.exports = __webpack_public_path__ + "img/clara.91d4d96b.svg";